export default __webpack_public_path__ + "images/7e6042a9e685aa8a29fa658f3621822c-andy-profile-small.svg";